export default __webpack_public_path__ + "static/media/personality@3x.0c0b23d4.png";